import { Typography, Grid } from '@mui/material';
import { Stack } from '@mui/system';
import { GetQuoteDetailsResponse } from 'Application/models';
import { FC } from 'react';

interface QuoteTravelDetailsProps {
    quoteDetailsData: GetQuoteDetailsResponse;
}

const QuoteTravelDetails: FC<QuoteTravelDetailsProps> = ({ quoteDetailsData }) => {
    const { quotation } = quoteDetailsData;

    const travellersAbove70 = quotation.travellersInUpperAgeRange + quotation.countBtw76TO80 + quotation.countBtw81TO85;

    return (
        <>
            <Typography variant="h4">Travel Details</Typography>
            <Grid container spacing={3} sx={{ mt: '1px' }}>
                <Grid item xs={12} sm={6} md={4}>
                    <Stack spacing={2}>
                        <Stack spacing={0}>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Travel type:</Typography>
                                <Typography variant="body2">{quotation.travelType.toTitle()}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Reason for travel:</Typography>
                                <Typography variant="body2">{quotation.reasonOfTravel.toTitle()}</Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Stack spacing={2}>
                        <Stack spacing={0}>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Travellers under 18 years:</Typography>
                                <Typography variant="body2">{quotation.travellersInLowerAgeRange.toString()}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Travellers between 18 and 69 years:</Typography>
                                <Typography variant="body2">{quotation.travellersInMedianAgeRange.toString()}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Travellers above 70 years:</Typography>
                                <Typography variant="body2">{travellersAbove70.toString()}</Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Stack spacing={2}>
                        <Stack spacing={0}>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Has COVID extension cover:</Typography>
                                <Typography variant="body2">{quotation.coverCovidExtension ? 'Yes' : 'No'}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">Has War and Terrorism cover:</Typography>
                                <Typography variant="body2">{quotation.coverWarAndTerrorism ? 'Yes' : 'No'}</Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default QuoteTravelDetails;
